import { useEffect } from 'react';
import CustomerBooking from './CustomerBooking';

/**
 * Embeddable version of the reservation form. Render at /embed.
 *
 * Designed to be loaded inside an <iframe> on the restaurant's own website:
 *   <iframe src="https://reservierung.lacontadina-dresden.de/embed"
 *           style="width:100%;height:780px;border:0;"></iframe>
 *
 * What changes vs. the standalone page:
 *   • Hero/marketing block is hidden — only the booking card is rendered
 *   • No drop shadow / outer border (host site provides framing)
 *   • Reduced top/bottom padding
 *   • On successful reservation, posts a `lacontadina:reservation-created`
 *     message to window.parent so host pages can react (close a modal, fire
 *     analytics, scroll, etc.)
 *   • Iframe height auto-reports to parent via postMessage on resize so the
 *     host can implement responsive iframe sizing
 */
export default function EmbedBooking() {
  // Inform the parent window of our document height so the iframe can resize.
  useEffect(() => {
    if (window.parent === window) return; // not embedded
    const post = () => {
      try {
        const h = document.documentElement.scrollHeight;
        window.parent.postMessage({ type: 'lacontadina:resize', height: h }, '*');
      } catch { /* noop */ }
    };
    post();
    const ro = new ResizeObserver(post);
    ro.observe(document.body);
    const interval = setInterval(post, 1500); // safety net for late content
    return () => { ro.disconnect(); clearInterval(interval); };
  }, []);

  return <CustomerBooking embed />;
}
